import React from "react";
import { colors, media, spacing } from "../theme";
import styled from "styled-components";
import Card from "../common/Card";
import Headline from "../common/Headline";
import Label from "../common/Label";
import Paragraph from "../common/Paragraph";
import Button from "../common/Button";
import { ContentRef, Media, MediaRef, Document } from "../../lib/CmsApi";
import { Image } from "../../lib/image";
import { responsiveBackgroundImage } from "../../lib/responsiveImage";
import getImageFocus from "../../lib/getImageFocus";

const Wrapper = styled(Card)<{ bg?: Image; isDownload?: boolean }>`
  color: ${p => (p.bg ? "white" : colors.blue)};
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  background: center / cover no-repeat;
  ${p =>
    p.bg
      ? responsiveBackgroundImage({
          image: p.bg,
          sizes: {
            0: 300
          }
        })
      : p.isDownload
      ? `background-color: ${colors.pigeonGrey}`
      : `background-color: ${colors.paleGreyTwo}`};
  ${p => p.bg && `background-position: ${getImageFocus(p.bg)};`}

  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${spacing("padding", 32)}
  ${spacing("margin-bottom", 32)}
  &:last-of-type {
    margin-bottom: 0;
  }
  @media screen and ${media.desktop} {
    width: 304px;
  }
`;
const Square = styled.div`
  width: 100%;
  padding-bottom: 100%;
`;

const StyledLabel = styled(Label)`
  color: inherit;
`;

const StyledHeadline = styled(Headline)`
  color: inherit;
`;

const StyledParagraph = styled(Paragraph)`
  color: inherit;
`;

const StyledButton = styled(Button)`
  z-index: 1;
`;

type Props =
  | {
      image?: Media & MediaRef;
      title: string;
      headline: string;
      copy: string;
      cta: string;
      link: ContentRef;
      _type: "Teaser";
    }
  | {
      title: string;
      headline: string;
      copy: string;
      cta: string;
      link: ContentRef & Document;
      _type: "DownloadTeaser";
    }
  | {
      _type: "Brand";
      image: Media & MediaRef;
    };

export default function Teaser(props: Props) {
  if (props._type === "Teaser" || props._type === "DownloadTeaser") {
    const { title, headline, copy, cta, link } = props;
    const isDownload = props._type === "DownloadTeaser";
    return (
      <Wrapper
        bg={"image" in props ? props.image : undefined}
        isDownload={isDownload}
      >
        <StyledLabel small>{title}</StyledLabel>
        <StyledHeadline size={4} level={2}>
          {headline}
        </StyledHeadline>
        <StyledParagraph tiny>{copy}</StyledParagraph>
        <StyledButton
          inverted={"image" in props && props.image !== null}
          small
          ghost
          light
          href={"file" in link ? link.file._src : link._url}
          aria-label={cta + ", " + headline}
        >
          {cta}
        </StyledButton>
      </Wrapper>
    );
  }
  if (props._type === "Brand") {
    const { image } = props;
    return (
      <Wrapper bg={image}>
        <Square />
      </Wrapper>
    );
  }
  return null;
}

Teaser.getImages = (p: Props) => {
  if ("image" in p) return [p.image];
  return [];
};
